import React from 'react';
import './index.scss';
import { api, apis } from 'api';
import AvatarTag from './avatarTag';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const Avatar = prop => {
    const { item: { contact: propContact }, size, style, innerStyle, } = prop;
    const contact = propContact;
    const avatarUrl = contact.avatar;
    const name = contact.contactName;
    const email = contact.email || contactApi.doGetModelDisplayEmail(prop.item);
    const contactId = contact.id;
    return React.createElement(AvatarTag, { size: size, contactId: contactId, propEmail: email, user: { name, avatar: avatarUrl }, style: style, innerStyle: innerStyle });
};
export default Avatar;
